import { render, staticRenderFns } from "./LayoutContent.vue?vue&type=template&id=03fcec5d&"
import script from "./LayoutContent.vue?vue&type=script&lang=js&"
export * from "./LayoutContent.vue?vue&type=script&lang=js&"
import style0 from "./LayoutContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports